import { AxiosError } from 'axios';
import { get } from '@/utils';
import { IAnnouncementPrioritiesResponse, IAnnouncementPriority } from './types';

// GET api/announcement-priorities → lista de priorități (nomenclator mic, îl cerem integral).
async function fetchAnnouncementPriorities(): Promise<IAnnouncementPriority[]> {
	try {
		const res = await get('api/announcement-priorities?PageNumber=1&PageSize=500');
		const data = res.data as IAnnouncementPrioritiesResponse | IAnnouncementPriority[];
		return Array.isArray(data) ? data : data.items ?? [];
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || 'Nu am reușit să accesăm prioritățile anunțurilor.');
	}
}

export { fetchAnnouncementPriorities };
